





































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class FormInput extends Vue {
  @Prop({ required: true })
  readonly value!: string | number | null;

  @Prop({ required: false, type: String, default: 'text' })
  readonly type!: string;

  @Prop({ required: false, type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ required: false, type: Array })
  errors!: string[];

  @Prop({ required: false, type: Boolean, default: false })
  readonly focused!: boolean;

  @Prop({ required: false, type: String })
  readonly rightUnit!: string;

  @Prop({ required: false, type: String })
  readonly valueType!: string;

  @Prop({ required: false, type: Array, default: () => [] })
  readonly options!: string[];

  showPopover = false; // For now, always show. Later, control this as needed.
  highlightedIndex = -1;

  mounted() {
    // if (this.focused) {
    //   this.$nextTick(() => {
    //     (this.$refs.input as HTMLInputElement).focus();
    //   });
    // }
    this.highlightedIndex = -1;
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event: MouseEvent) {
    if (this.$el && !this.$el.contains(event.target as Node)) {
      this.showPopover = false;
    }
  }

  get filteredOptions() {
    const valueString = this.value == null ? '' : this.value.toString();
    const options =
      valueString.length > 1
        ? this.options.filter(
            (option) =>
              option.toString().toLowerCase() !== valueString.toLowerCase() &&
              option.toString().toLowerCase().includes(valueString.toLowerCase()),
          )
        : [];
    // Reset highlight if options change
    if (this.highlightedIndex >= options.length) {
      this.highlightedIndex = options.length - 1;
    }
    return options.slice(0, 5);
  }

  updateValue(value: string) {
    if (this.valueType === 'currency') {
      value = value.replace(',', '.');
    }
    this.$emit('input', value);
    this.showPopover = true;
  }

  selectOption(option: string) {
    console.log('selectOption', option);
    this.$emit('input', option);
    this.showPopover = false;
  }

  onKeydown(event: KeyboardEvent) {
    const options = this.filteredOptions;
    if (!options.length) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (this.highlightedIndex < options.length - 1) {
        this.highlightedIndex++;
      } else {
        this.highlightedIndex = 0;
      }
      this.showPopover = true;
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
      } else {
        this.highlightedIndex = options.length - 1;
      }
      this.showPopover = true;
    } else if (event.key === 'Enter') {
      if (this.highlightedIndex >= 0 && this.highlightedIndex < options.length) {
        this.selectOption(options[this.highlightedIndex]);
        event.preventDefault();
      }
    } else if (event.key === 'Escape') {
      this.showPopover = false;
    }
  }

  onFocus() {
    if (this.filteredOptions.length > 0) {
      this.showPopover = true;
    }
  }

  onBlur() {
    this.showPopover = false;
    this.highlightedIndex = -1;
  }
}
